import { render, staticRenderFns } from "./PortalTextarea.vue?vue&type=template&id=54a7a57d&scoped=true&"
import script from "./PortalTextarea.vue?vue&type=script&lang=ts&"
export * from "./PortalTextarea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a7a57d",
  null
  
)

export default component.exports